import dropRepeats from 'xstream/extra/dropRepeats'
import fromEvent from 'xstream/extra/fromEvent'
import xs from 'xstream'

export default function makeInteractionDriver (element) {
  return () => {
    return {
      size: () =>
        fromEvent(window, 'resize')
          .startWith({})
          .map(() => ({
            width: element.innerWidth || element.width,
            height: element.innerHeight || element.height,
          }))
          .remember(),

      scroll: () =>
        fromEvent(element, 'scroll')
          .map(() => ({
            top: element.scrollTop,
            left: element.scrollLeft,
          }))
          .remember(),

      mouseMove: () => xs.merge(
        fromEvent(element, 'mousemove'),
        fromEvent(element, 'touchmove')
          .map(evt => evt.changedTouches[0]),
        fromEvent(element, 'touchend')
          .map(evt => evt.changedTouches[0]),
        fromEvent(element, 'touchstart')
          .map(evt => evt.changedTouches[0]),
      )
        .compose(dropRepeats()),

      mouseUp: () => xs.merge(
        fromEvent(element, 'mouseup'),
        fromEvent(element, 'touchend')
          .map(evt => evt.changedTouches[0]),
      )
        .compose(dropRepeats())
        .remember(),

      mouseDown: () =>
        fromEvent(element, 'mousedown')
          .compose(dropRepeats())
          .remember(),

      doubleClick: () =>
        fromEvent(element, 'dblclick')
          .compose(dropRepeats())
          .remember(),

      mouseLeave: () =>
        fromEvent(element, 'mouseleave')
          .remember(),

      keyDown: () =>
        fromEvent(element, 'keydown')
          .remember(),
    }
  }
}



// WEBPACK FOOTER //
// ./drivers/interactionDriver.js